import { useEffect, useState } from 'react';
import axios from 'axios';
import { Flame } from 'lucide-react';
import { DAILY_SUPER_PITCH, DAILY_SUPER_SUB } from './DailySuperMeter';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Player-facing Daily Super Jackpot strip: shows only on enabled days.
export const DailySuperBanner = () => {
    const [d, setD] = useState(null);
    useEffect(() => {
        let alive = true;
        const load = () => axios.get(`${API}/jackpots/daily-super`).then(({ data }) => { if (alive) setD(data); }).catch(() => {});
        load();
        const iv = setInterval(load, 20000);
        return () => { alive = false; clearInterval(iv); };
    }, []);
    if (!d?.active) {
        const h = d?.banner_hit;
        if (!h) return null;
        return (
            <div className="mb-4 flex items-center gap-3 rounded-2xl border-2 border-[#FFB000] bg-gradient-to-r from-[#3a0a04] via-[#1a0410] to-[#0d0610] px-4 py-3"
                style={{ boxShadow: '0 0 18px #FF7A0066' }} data-testid="daily-super-hit-banner">
                <Flame className="h-6 w-6 shrink-0 text-[#FF7A00]" />
                <div className="min-w-0 flex-1">
                    <div className="text-[11px] font-black uppercase tracking-[0.2em] text-[#FF8A80]">Daily Super Jackpot</div>
                    <div className="text-sm text-white" data-testid="daily-super-hit-banner-text">
                        <b>The Daily Super was just hit by <span className="text-[#FFD700]">{h.winner}</span>!</b> Congratulations!
                    </div>
                </div>
                <div className="text-right text-xl font-black text-[#FFD700] tabular-nums" data-testid="daily-super-hit-banner-amount">
                    ${Number(h.amount || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </div>
            </div>
        );
    }
    return (
        <div className={`mb-4 flex items-center gap-3 rounded-2xl border-2 ${d.hot ? 'border-[#FFB000] animate-pulse' : 'border-[#FF3B30]/70'} bg-gradient-to-r from-[#2a0606] via-[#1a0410] to-[#0d0610] px-4 py-3`}
            data-testid="daily-super-banner">
            <Flame className="h-6 w-6 shrink-0 text-[#FF3B30]" />
            <div className="min-w-0 flex-1">
                <div className="text-[11px] font-black uppercase tracking-[0.2em] text-[#FF8A80]">Daily Super Jackpot</div>
                <div className="text-sm text-white/80" data-testid="daily-super-banner-text">
                    <b className="text-white">{DAILY_SUPER_PITCH}</b> — {DAILY_SUPER_SUB.toLowerCase()}
                </div>
            </div>
            <div className="text-right text-xl font-black text-[#FFD700] tabular-nums" data-testid="daily-super-banner-amount">
                ${Number(d.amount || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </div>
        </div>
    );
};

export default DailySuperBanner;
